/**
 * 应用常量定义
 */

// 错误消息映射
export const ERROR_MESSAGES: Record<string, string> = {
  '10001': 'API Key无效',
  '10002': '请求过于频繁',
  '10003': '访问超限',
  '10004': '请求服务不存在',
  '10021': 'QPS超限',
  '20001': '无效参数',
  '20003': '地址解析失败'
};

// 示例地址列表
export const EXAMPLE_ADDRESSES: string[] = [
  '北京市朝阳区建国门外大街1号国贸大厦',
  '上海市黄浦区南京东路20号',
  '广州市天河区珠江新城花城大道85号',
  '深圳市南山区深南大道10000号',
  '杭州市西湖区文三路90号',
  '成都市高新区天府大道中段801号',
  '武汉市江汉区解放大道688号',
  '西安市雁塔区科技路33号'
];

// localStorage 键名
export const STORAGE_KEYS = {
  API_KEY: 'amapApiKey',
  SECURITY_KEY: 'amapSecurityKey'
} as const;

// 地图配置
export const MAP_CONFIG = {
  DEFAULT_CENTER: [116.397428, 39.90923] as [number, number], // 北京中心
  DEFAULT_ZOOM: 10,
  MAP_STYLE: 'amap://styles/normal'
} as const;

// 配额配置
export const QUOTA_CONFIG = {
  MAX_QPS: 10, // 免费版QPS限制
  BASE_DELAY: 200, // 基础延迟ms
  MAX_DELAY: 10000, // 最大延迟ms
  MAX_RETRIES: 3, // 最大重试次数
  RETRY_DELAY: 3000 // 重试延迟ms
} as const;

// 地理编码器配置
export const GEOCODER_CONFIG = {
  TIMEOUT_MS: 10000
} as const;
